import moment from "moment";
import React, { useEffect, useState } from "react";
import api from "../../api";
import BillingTable from "../../components/BillingTable";
import Header from "../../components/Header";
import { StyledMainContainer } from "../../styles/global";
import {
  StyledAccountInfo,
  StyledBillingInfo,
  StyledProfileContainer,
  StyledProfileHeader,
  StyledTab,
  StyledTabs,
} from "./styled";

const Profile = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [profile, setProfile] = useState<any>(null);

  const tabs = [
    {
      label: "Account",
      value: 0,
    },
    {
      label: "Billing",
      value: 1,
    },
  ];

  const fetchProfile = async () => {
    await api.GetUserProfile().then((res) => {
      setProfile(res.data.data);
    });
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (!profile) {
    return null;
  }

  return (
    <>
      <Header title="WhatQR" />

      <StyledMainContainer>
        <StyledProfileContainer>
          <StyledProfileHeader>
            <h1>{profile.user?.name}</h1>
            <p>{profile.user?.email}</p>
          </StyledProfileHeader>
          <StyledTabs>
            {tabs.map((t, i) => (
              <StyledTab
                key={i}
                active={currentTab === t.value}
                onClick={() => {
                  setCurrentTab(t.value);
                }}
              >
                {t.label}
              </StyledTab>
            ))}
          </StyledTabs>
          {currentTab === 0 && (
            <StyledAccountInfo>
              <div>
                <p>Customer ID:</p>
                <p className="mobile-val">{profile.user._id}</p>
                <p>Joined date:</p>
                <p className="mobile-val">
                  {moment(profile.user.createdAt).format("MMM Do, YYYY")}
                </p>
                <p>Current Plan:</p>
                <p className="mobile-val">
                  {profile.plan}{" "}
                  {profile.user.currentPlan !== "twelve_months" ? (
                    <a href="/#pricing_section">Upgrade plan</a>
                  ) : null}
                </p>
                {profile.planCreatedAt && <p>Plan purchased at:</p>}
                {profile.planCreatedAt && (
                  <p className="mobile-val">
                    {moment(profile.planCreatedAt).format("MMM Do, YYYY")}
                  </p>
                )}
                {profile.planExpiresAt && <p>Plan expires at:</p>}
                {profile.planExpiresAt && (
                  <p className="mobile-val">
                    {moment(profile.planExpiresAt).format("MMM Do, YYYY")}
                  </p>
                )}
                <p>QR Codes:</p>
                <p className="mobile-val">
                  {profile.qrs}/{profile.allowedQrs}
                </p>
                <p>Short URLs:</p>
                <p className="mobile-val">
                  {profile.shortUrls}/{profile.allowedShortUrls}
                </p>
              </div>
              <div>
                <p className="desktop-val">{profile.user._id}</p>

                <p className="desktop-val">
                  {moment(profile.user.createdAt).format("MMM Do, YYYY")}
                </p>

                <p className="desktop-val">
                  {profile.plan}{" "}
                  {profile.user.currentPlan !== "twelve_months" ? (
                    <a href="/#pricing_section">Upgrade plan</a>
                  ) : null}
                </p>
                {profile.planCreatedAt && (
                  <p className="desktop-val">
                    {moment(profile.planCreatedAt).format("MMM Do, YYYY")}
                  </p>
                )}
                {profile.planExpiresAt && (
                  <p className="desktop-val">
                    {moment(profile.planExpiresAt).format("MMM Do, YYYY")}
                  </p>
                )}
                <p className="desktop-val">
                  {profile.qrs}/{profile.allowedQrs}
                </p>

                <p className="desktop-val">
                  {profile.shortUrls}/{profile.allowedShortUrls}
                </p>
              </div>
            </StyledAccountInfo>
          )}

          {currentTab === 1 && (
            <StyledBillingInfo>
              {profile.orders && profile.orders?.length > 0 ? (
                <BillingTable
                  data={profile.orders}
                  onDownload={(order) => {}}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                    alt="no-info"
                    style={{
                      // convert image in black and white
                      filter: "grayscale(100%)",
                    }}
                  />
                  <p>No billing information</p>
                </div>
              )}
            </StyledBillingInfo>
          )}
        </StyledProfileContainer>
      </StyledMainContainer>
    </>
  );
};

export default Profile;
